import React from 'react';
import { Box } from 'grommet';

import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';
import SHDText from '@ui/Text/SHDText';
interface TeamInfoProps {
  name: string;
  ageLevel: string;
  sport: string;
}

const TeamInfo: React.FC<TeamInfoProps> = ({ name, ageLevel, sport }) => {
  return (
    <SHDThemeOverride full={false}>
      <Box key="team-info" gap="xxxsmall">
        <SHDText style="subhead-bold" color="#212121">
          {name}
        </SHDText>

        {ageLevel && sport && (
          <SHDText style="subhead" color="#272727">
            {`${ageLevel} ${sport} Team`}
          </SHDText>
        )}
      </Box>
    </SHDThemeOverride>
  );
};

export default TeamInfo;
